// noinspection JSUnusedGlobalSymbols
import {enableProdMode} from "@angular/core";

export const environment = {
    production: true,
    commitHash: 'deadbeefcafebabefacefeeddeadc0debedabb1e',
};

enableProdMode();
